import React from 'react';
import { Link } from 'react-router-dom';
import Services from '../../api/Services';

const ServiceSidebar = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <div className='service-sidebar'>
      <div className='service-catagory'>
        <ul>
          {Services.slice(0, 5).map((serves, index) => (
            <li key={index}>
              <Link to={`/services/${serves.slug}`} onClick={ClickHandler}>
                {serves.title} <i className='flaticon-right-arrow-1'></i>
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div className='service-info'>
        <div className='icon'>
          <i className='flaticon-email'></i>
        </div>
        <h2>Need help planning your shipment?</h2>
        <span>Speak with our team</span>
        <div className='num'>
          <a href='mailto:support@ferrygoldshipping.com'>
            support@ferrygoldshipping.com
          </a>
        </div>
      </div>
    </div>
  );
};

export default ServiceSidebar;
